import React from 'react';

import { RoutesConfiguration } from '../store/router/router.types';
import Authenticator from './Authenticator';
import SectionRouter from '../shared/SectionRouter/SectionRouter';
import {
  errorManagementRoutesConfig,
  errorManagementRoutesPaths,
} from '../shared/ErrorManagement/ErrorManagementRoutes';
import { accessDeniedRoutesConfig, accessDeniedRoutesPaths } from './AccountManagement/AccessDenied/AccessDeniedRoutes';

export const publicRoutesConfig: RoutesConfiguration = {
  shared: [
    {
      path: accessDeniedRoutesPaths.accessDeniedRoot,
      component: () => <SectionRouter routeConfig={accessDeniedRoutesConfig} />,
    },
    {
      path: errorManagementRoutesPaths.errorManagementRoot,
      component: () => <SectionRouter routeConfig={errorManagementRoutesConfig} />,
    },
    {
      path: '/',
      component: Authenticator,
    },
  ],
};
